import { render, staticRenderFns } from "./WatchHeartRateFullscreen.vue?vue&type=template&id=ed78d1d4"
import script from "./WatchHeartRateFullscreen.vue?vue&type=script&lang=js"
export * from "./WatchHeartRateFullscreen.vue?vue&type=script&lang=js"
import style0 from "./WatchHeartRateFullscreen.vue?vue&type=style&index=0&id=ed78d1d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports